import React, { useState } from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
} from "antd";

import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import dealBannerImg from "../assets/images/dealBanner.png";
import sliderImg from "../assets/images/bannerHotel.jpg";
import ReviewSlider from "../components/ReviewSlider";
import { tours } from "../data/toursData";
import FAQAccordion from "../components/FAQAccordion";
import ExploreAttractions from "../components/ExploreAttractions";
import ExplorePlaces from "../components/ExplorePlaces";
import AllSubSubCategoryBoxes from "../components/AllSubSubCategoryBoxes";
import CategorySection from "../components/CategorySection";
import HotelSearchUI from "../components/HotelSearchForm";
import CategorySectionHotel from "../components/CategorySectionHotel";
import HolidaySearchBanner from "../components/HolidaySearchBanner";
import HolidayCardCategory from "../components/HolidayCardCategory";
const { Text, Paragraph, Title } = Typography;

const offers = [
  {
    img: spatialImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialTowImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialThreeImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
];

// const tours = [
//   {
//     id: 1,
//     image: exploreCountryImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Standard",
//     tagColor: "blue",
//     badgeColor: "#10239E",
//   },
//   {
//     id: 2,
//     image: exploreCountryTwoImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Premium",
//     tagColor: "gold",
//     badgeColor: "#D72638",
//   },
//   {
//     id: 3,
//     image: exploreCountryThreeImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Value",
//     tagColor: "green",
//     badgeColor: "#D72638",
//   },
//   {
//     id: 4,
//     image: exploreCountryThreeImg,
//     price: "INR 1,43,200",
//     oldPrice: "INR 2,65,185",
//     savings: "SAVE INR 1,21,985",
//     type: "Value",
//     tagColor: "green",
//     badgeColor: "#D72638",
//   },
// ];

const sampleHotel = {
  title: "Amazing Dubai with Indian Meal Special - Seal Deal",
  subtitle: "Seal Deal with Flights & Meals",
  duration: "5N/6D",
  features: [
    "Round Trip Flights",
    "4 Star Hotel",
    "Airport Transfers",
    "15 Activities",
    "Visa",
    "Selected Meals",
  ],
  hotelOptions: "Ramada by Wyndham Abu Dhabi Corniche or similar",
  tourOptions: "Arrival & NBA Abu Dhabi Game Night, Departure",
  oldPrice: "2,65,185",
  price: "1,43,200",
  taxes: "7,650",
  reviews: 523,
  images: [
    "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
    "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
    "https://images.unsplash.com/photo-1493558103817-58b2924bce98",
    "https://images.unsplash.com/photo-1526772662000-3f88f10405ff",
  ],
};

const HolidayListPage = () => {
  const [selectedTour, setSelectedTour] = useState(tours[0]);
  // Store selected by ID instead of index
  const [selectedTourId, setSelectedTourId] = useState(tours[0].id);

  // Find active tour
  const activeTour = tours.find((t) => t.id === selectedTourId);

  return (
    <>
      <section>
        <HolidaySearchBanner />
      </section>

      <section className="py-6 px-4 lg:px-0 mt-8">
        <HolidayCardCategory />
      </section>

      {/* Banner Slider  */}
      <section className="p-6">
        <div className="container">
          <Carousel
            autoplay
            dots
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <div className="flex items-center">
              <div className="absolute z-10 inset-0 bg-[linear-gradient(90deg,_rgba(221,21,21,0.8)_0%,_#EC1C1D_100%)]" />
              <Image
                src={sliderImg}
                alt="Slide 1"
                className="w-full !h-full object-cover"
                preview={false}
              />

              <Flex
                className="absolute items-center z-20 inset-0 text-white px-12 py-8"
                align="start"
                justify="space-between"
              >
                <Flex flex={1} justify="space-between" className="" vertical>
                  <Flex justify="start" vertical align="start">
                    <Title
                      level={1}
                      className="!text-white rounded !font-medium !mb-0 !text-4xl"
                    >
                      Experience the Wow
                    </Title>

                    <Title
                      level={2}
                      className="!text-white uppercase rounded !text-5xl !mt-2 !mb-0"
                    >
                      in Every Stay
                    </Title>

                    {/* CTA Button */}
                    <Button
                      type="danger"
                      size="large"
                      className="font-medium text-xl bg-white mt-8 
                      border-none rounded-md px-16 py-8 text-[12273D] w-fit"
                    >
                      Book Now!
                    </Button>
                  </Flex>
                </Flex>

                <Flex
                  flex={1}
                  justify="center"
                  align="center"
                  className=""
                  vertical
                >
                  {/* Box Outline */}

                  <fieldset class="w-full mt-8 border-2 border-white border-solid rounded-[8px] p-6 text-white inline-block relative">
                    <legend class="px-4 w-auto text-xl font-semibold !mb-0 text-center">
                      STARTING PRISE
                    </legend>
                    {/* Diagonal Badge */}
                    <div className="absolute -top-5 -right-8 transform rotate-45 bg-blue-600 text-white text-lg font-bold px-3 py-[2px] shadow-md">
                      <Title
                        level={4}
                        className="!text-white !mb-0 !font-medium"
                      >
                        4N/5D
                      </Title>
                    </div>

                    {/* Price Text */}
                    <h1 className="large font-black leading-none text-center">
                      INR 35,999
                    </h1>
                    <p className="uppercase text-center text-xl font-semibold tracking-wide">
                      PER PERSON (BASED ON 2 PAX)
                    </p>
                  </fieldset>

                  <Flex
                    vertical
                    className="w-[60%] mx-auto"
                    justify="center"
                    align="center"
                  >
                    {/* Decorative Line */}
                    <div className="w-full h-[4px] bg-white rounded-full mt-10 mx-auto"></div>
                  </Flex>
                </Flex>
              </Flex>
            </div>
          </Carousel>
        </div>
      </section>

      <section className="py-6">
        <ExplorePlaces />
      </section>
    </>
  );
};

export default HolidayListPage;
